import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classnames from 'classnames';
import { useId } from '@nerdwallet/react-accessibility';
import style from './CardSelect.module.less';
export var CardSelect = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var autoFocus = props.autoFocus,
      className = props.className,
      dangerouslyForceActiveStyling = props.dangerouslyForceActiveStyling,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      dangerouslyForceSelectedStyling = props.dangerouslyForceSelectedStyling,
      disabled = props.disabled,
      nameProp = props.name,
      onChange = props.onChange,
      options = props.options,
      selectedValue = props.value,
      otherProps = _objectWithoutProperties(props, ["autoFocus", "className", "dangerouslyForceActiveStyling", "dangerouslyForceFocusStyling", "dangerouslyForceHoverStyling", "dangerouslyForceSelectedStyling", "disabled", "name", "onChange", "options", "value"]);

  var createChangeHandler = function createChangeHandler(value) {
    return function () {
      onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
  }; // `name` is used to link related radio buttons together for keyboard
  // navigation. If the name isn't provided, we can use `useId()` to generate
  // one, since it doesn't really matter what the name is as long as it's a
  // globally-unique string.


  var name = useId(nameProp); // disabling this rule because we do use nesting by putting the input inside of the label
  // this is valid according to this page https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/label-has-for.md

  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: classnames(style.container, className),
    ref: ref
  }), options.map(function (_ref, index) {
    var _classnames;

    var label = _ref.label,
        value = _ref.value,
        optionDisabled = _ref.disabled;
    var isChecked = value === selectedValue; // only pass this prop in if props.autoFocus is true

    var autoFocusProp = // use autoFocus on the first selected card, and if none are selected, the first card
    autoFocus && (selectedValue ? isChecked : index === 0);
    var isDisabled = disabled || optionDisabled;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(style.option, className)
    }, /*#__PURE__*/React.createElement("label", {
      className: classnames(style.label, (_classnames = {}, _defineProperty(_classnames, style.labelSelected, isChecked), _defineProperty(_classnames, style.disabled, isDisabled), _defineProperty(_classnames, style['force-active'], dangerouslyForceActiveStyling), _defineProperty(_classnames, style['force-focus'], dangerouslyForceFocusStyling), _defineProperty(_classnames, style['force-hover'], dangerouslyForceHoverStyling), _defineProperty(_classnames, style['force-selected'], dangerouslyForceSelectedStyling), _classnames))
    }, label, /*#__PURE__*/React.createElement("input", {
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus: autoFocusProp,
      type: "radio",
      className: style.input,
      onChange: createChangeHandler(value),
      checked: isChecked,
      disabled: isDisabled,
      name: name
    })));
  }));
});